export class TexmlApplicationsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getTexmlApplications() {
    return this.#http.get('/api/telnyx/texml-applications');
  }

  async getTexmlApplication({ id }) {
    return this.#http.get(`/api/telnyx/texml-applications/${id}`);
  }

  async createTexmlApplication({ data }) {
    return this.#http.post('/api/telnyx/texml-applications', data);
  }

  async updateTexmlApplication({ id, data }) {
    return this.#http.put(`/api/telnyx/texml-applications/${id}`, data);
  }

  async deleteTexmlApplication({ id }) {
    return this.#http.delete(`/api/telnyx/texml-applications/${id}`);
  }

  async getPhoneNumbers() {
    return this.#http.get('/api/telnyx/phone-numbers');
  }
}
